'use strict';
import isNumber from 'lodash/isNumber';
import memoize from 'lodash/memoize';
import moment from 'moment';
import 'moment-duration-format';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';

export function DateHeaderView(props) {
  return (
    <div className={classNames('DateHeader', props.className)}>
      <span className="DateHeader__label">
        {isNumber(props.date) ? props.formatDate(props.date) : props.date}
      </span>
    </div>
  );
}

DateHeaderView.propTypes = {
  className: T.string,
  /** @type {String|Number} String, or milliseconds from Unix Epoc */
  date: T.oneOfType([
    T.string,
    T.number,
  ]),
  formatDate: T.func.isRequired,
};

DateHeaderView.defaultProps = {
  formatDate: memoize(date => isNumber(date) ? moment(date).format('ll') : date),
};



// WEBPACK FOOTER //
// ./src/js/components/lists/DateHeader/DateHeaderView.js